<template>
	<div :class="['c-generations-item', { active: active === true }]">
		<header @click="toggle">
			<article>
				<span v-html="svg"> </span>
				<strong> {{ scriptType }} • {{ date }} • {{ by }}</strong>
			</article>

			<section>
				<label title="Status" class="status">
					<svg
						v-if="generation.status === 'DONE'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M7 13L10 16L17 8"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<svg
						v-if="generation.status === 'PROCESSING'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M12.0003 3V6M12.0003 18V21M5.63634 5.63604L7.75766 7.75736M16.2429 16.2426L18.3643 18.364M3 12.0007H6M18 12.0007H21M5.63634 18.364L7.75766 16.2426M16.2429 7.75736L18.3643 5.63604"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<svg
						v-if="generation.status === 'FAILED'"
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M8 8L16 16M16 8L8 16"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
						/>
					</svg>

					<span> {{ generation.status.toLowerCase() }} </span>
				</label>
				<label title="Credits used" class="credits-consumed">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9 16C5.68629 16 3 13.3137 3 10C3 6.68629 5.68629 4 9 4C11.4597 4 13.5737 5.48012 14.5 7.59829M21 14C21 17.3137 18.3137 20 15 20C12.3841 20 10.1591 18.3259 9.33811 15.9906C9.11911 15.3677 9 14.6978 9 14C9 10.7998 11.5055 8.1847 14.6619 8.00937C14.7738 8.00315 14.8865 8 15 8C18.3137 8 21 10.6863 21 14Z"
							stroke="currentColor"
							stroke-width="2"
						/>
					</svg>

					<span>
						{{ generation.creditsUsed }}
					</span>
				</label>
			</section>

			<svg
				class="expand"
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M8 10L11.4697 13.4697C11.7626 13.7626 12.2374 13.7626 12.5303 13.4697L16 10"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
			</svg>
		</header>

		<main v-if="active">
			<RenderScript :generation="generation"></RenderScript>
		</main>
	</div>
</template>

<script>
import dayjs from 'dayjs';

import scripts from '@swipekit/lib/scripts';

import RenderScript from '@swipekit/components/utils/render-script';

export default {
	components: {
		RenderScript,
	},

	data: function () {
		return {
			active: false,
		};
	},

	props: {
		generation: {},
	},

	computed: {
		svg: function () {
			let type = this.generation.type;
			let svg = '';

			for (let i = 0; i < scripts.length; i++) {
				let script = scripts[i];

				if (script.value === type) {
					svg = script.icon;
					break;
				} else {
					//console.log(script.value, type);
				}
			}

			return svg;
		},
		date: function () {
			let str = this.generation.createdAt;
			return dayjs(str).format(`h:MMa, D MMM`);
		},
		scriptType: function () {
			let str = '';

			for (let i = 0; i < scripts.length; i++) {
				const script = scripts[i];
				if (script.value === this.generation.type) {
					str = script.key;
				}
			}

			return str;
		},
		users: function () {
			const workspace = this.$store.getters['workspaces/all'];

			return workspace.users;
		},
		by: function () {
			if (this.generation.userId) {
				const userId = this.generation.userId;
				let name = '';
				for (let i = 0; i < this.users.length; i++) {
					const user = this.users[i];
					if (user.id === userId) {
						name = `By ${user.name}`;
						if (user.lastName) {
							name = `${name} ${user.lastName}`;
						}
						break;
					}
				}
				return name;
			} else {
				return '';
			}
		},
	},

	methods: {
		toggle: function () {
			this.active = !this.active;
		},
	},
};
</script>

<style lang="scss">
.c-generations-item {
	margin-bottom: 0.5rem;
	background-color: var(--color-bg-1);
	border-radius: var(--border-radius);
	border: var(--color-bg-4) solid 1px;
	overflow: hidden;

	> header {
		position: relative;
		padding: 0.5rem;
		cursor: pointer;

		&:hover {
			background-color: var(--color-bg-2);
		}

		> svg {
			position: absolute;
			top: 1.25rem;
			right: 1rem;
		}

		article {
			display: flex;
			align-items: center;
			margin-bottom: 0.25rem;

			> span {
				display: inline-block;
				width: 24px;
				height: 24px;
				margin-right: var(--margin);
			}

			strong {
				font-weight: 500;
				font-size: var(--font-size-xs);
				line-height: 1;
			}

			> p {
				display: flex;
				align-items: center;
				margin: 0;
			}
		}
	}

	> main {
		border-top: var(--color-bg-3) solid 1px;
	}

	header > section > label {
		display: inline-flex;
		margin-right: var(--margin);
		padding: var(--margin-sm) var(--margin);
		align-items: center;
		font-size: var(--font-size-xxs);
		font-weight: 500;
		line-height: 1;
		background-color: var(--color-bg-3);
		border-radius: var(--border-radius);
		user-select: none;

		span {
			text-transform: capitalize;
		}

		svg {
			width: 20px;
			height: 20px;
			margin-right: var(--margin-sm);
		}
	}

	&.active {
		header {
			> svg {
				display: inline-block;
				&:last-of-type {
					transform: rotate(180deg);
				}
			}
		}
	}
}
</style>
